var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('incomeSections.incomeSections'),"description":_vm.$t('incomeSections.fromHereControlOverIncomeSections')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('incomeSections.SearchForARating'),"emptyTableText":_vm.$t('incomeSections.thereAreNoSections'),"localData":true,"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"buttonRole":_vm.$user.role.incomes_add,"cloumns":[
          {
            column: 'name',
            title: _vm.$t('incomeSections.sectionName'),
            type: 'text',
            sort: true
          },
          {
            column: 'income_section_id',
            title: _vm.$t('incomeSections.fatherSection'),
            type: 'link',
            to: 'incomeSection',
            sort: true,
            link: false
          },
          {
            column: 'options',
            title: _vm.$t('incomeSections.settings'),
            type: 'options',
            options: [
              { name: 'edit', role: _vm.$user.admin || _vm.$user.role.incomes_edit },
              {
                name: 'delete',
                role: _vm.$user.admin || _vm.$user.role.incomes_delete
              }
            ]
          }
        ],"deleteText":{
          attention: _vm.$t('allerts.Attention'),
          areYouReallySureToDeleteTheItem: _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
          close: _vm.$t('allerts.close'),
          confirm: _vm.$t('allerts.confirm'),
          loading: _vm.$t('allerts.loading')
        }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }